/* eslint-disable max-statements */
/* eslint-disable no-constant-condition */
/* eslint-disable complexity */
/* eslint-disable max-lines */
import assert from 'assert';
import {useRef, useState, useEffect, useCallback} from 'react';
import {useIntl} from 'react-intl';
import classNames from 'classnames';
import SearchInput from './searchInput';
import NoPerson from '@/components/shareCollaborate/search/noPerson';
import sdk from '@/sdk';
import {onSearch, departmentOnSearch, getRoleName} from '@/sdk/server/search';
import {PowerListOption, SinglePersonData, VirtualUserProps} from '@/interface';
import {
    Role,
    DocRole,
    DepartmentRole,
    MemberType,
    STATUS,
    ShareInviteModalType,
    ShareInviteModalSource,
    MAX_SUGS_NUM,
    EnumShareInviteType,
    RepositoryScope,
    shareInviteDisplayType,
    InheritRepo,
} from '@/Constant';
import {shareToRuLiu} from '@/domains/space/components/docOperate/shareUtils';
import {ErrorCode} from '@/sdk/common/error';

import Checkbox from '@/components/Checkbox';
import Button, {ButtonSize} from '@/components/Button';
import toast, {ToastType} from '@/components/Toast';
import Icon, {IconSize} from '@/components/Icon';
import {
    LoadFailedSvg,
    ArrowLeftSvg,
    NoteTipSvg,
    LoadNoResultSvg,
    LoadNoDataSvg,
    CloseSvg,
    InfoSvg,
    SettingWarnSvg,
} from '@/icons';
import CheckItem from '@/components/shareCollaborate/search/searchListItem';
import {uniqueId, throttle, divide} from 'lodash-es';
import {
    feLogger,
    docShareInvite,
    shareDepartment,
    clickShareModalBtn,
    PageType,
    searchScene,
    searchClickScene,
    addMember,
    DocType,
    MemberPermission,
    ShareSource,
    shareCardToRuLiu,
    enterAddMemberModal,
    enterShareToRuLiuPopper,
    permissionsOpenDept,
    clickAddMemberPageRecommendGroup,
} from '@/buried';
import styles from './css/searchContent.module.scss';
import {
    curDocCanInviteAdmin,
    curDocCanInviteEditor,
    curDocCanInviteReader,
    isAdminRepository,
    curUserRepositoryInviteMember,
}
    from '@/store/util';
import Tooltip from '@/components/Tooltip';
import PowerList from '@/components/DropMenu/clickDropMenu/index';
import Loading from '@/components/Loading';
import {isPersonal} from '@/domains/space/Repository/Utils/fixRepositoryNameWithPersonal';
import {concatImgSrc} from '@/utils/avatarUtils';
import {getPageType} from '../utils.tsx/member';
import * as store from '@/store';
import {v1 as uuidv1} from 'uuid';
import {BOOK_TYPE} from '@/constants/document/doc';
import kuPiper from '@/middleware/kuPiper';
import {LOG_DOC_TYPE} from '@/buried/performance/const';
import {curUserHaveRlId} from '@/utils/user';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';
import {clickShareBtnLog} from '@/buried/viespermission';
import SearchGroup from './SearchGroup';
const PREFIX = 'searchContent';
const getCls = (cls: string) => `${PREFIX}-${cls}`;

export interface Iitems {
    isDept?: any;
    groupGuid?: string | undefined;
    spaceGuid?: string | undefined;
    isAdded?: boolean;
    isHandle?: boolean;
    gid?: number | string;
    name?: string | undefined;
    rlId?: any;
    memberGuid?: string;
    rocRoleName?: string;
    roleName?: string;
    directoryRoleName?: string;
    memberType?: number;
    tenantId?: string | number | undefined;
    userGuid?: string;
    email?: string;
    id?: number;
    nickname?: string;
    avatar?: string;
    department?: string;
    status?: number;
    edit?: boolean;
    virtualUser?: VirtualUserProps;
    isVirtualUser?: boolean;
    // add
    randomId?: string;
    canAuth?: boolean;
    checked?: boolean;
    childrenMember?: [];
    openChildStatus?: boolean;

    // email
    emailGroupAddress?: string;
    hlEmailGroupAddress?: string;

    // externalRepo外部知识库字段
    passportId?: string;
    passportName?: string;
    mobile?: string;
    isExternalUser?: boolean;
}

interface IShareInviteProps {
    className?: string;
    title?: string;
    backMergeModal?: () => void;
    onAdded?: (roleName?: string) => void;
    showCancel?: boolean;
    showClose?: boolean;
    hideDepartmentItem?: boolean;
    handleClose?: () => void;
    docGuid?: string;
    repository?: Repository;
    curDepartment?: Department;
    curDocument?: WizDocument;
    // 下拉赋权
    // showPowerList?: boolean;
    powerListOptions?: PowerListOption[];
    powerValue?: string;
    powerListClassName?: string;
    userGuid?: string;
    onChange?: (value: Iitems[]) => void;
    shareInviteConfig: {
        source: string;
        type: string;
        displayType: string;
    };
    memberInfoMaxWidth?: {[index: string]: number};
    changeOptionsList?: (value?: any) => void;
    changePowerValue?: (value?: any) => void;
    shareContent?: string;
    externalShareMethod?: (users: SinglePersonData[]) => Promise<void>;
    version?: string;
    filterUser?: string;
    // 是否可以搜索到敏感用户——高管用户
    isSearchSensitiveUser?: boolean;
    onConfirm?: (val: any, powerVal: string)=> void;
    memberList?: Iitems[];
    // 是否可以搜索外部成员，默认false
    isSearchExternalUser?: boolean;
}

enum banJurisdiction {
    'AAOwner' = '负责人',
    'Admin' = '管理员',
    'Member' = '成员',
}

const Skeleton = ({length = 3}: {length?: number}) => {
    return (<>
        {
            Array.from({length}).map(item => {
                return (<div key={`key-${uuidv1()}`} className={getCls('skeletonWrap')}>
                    <div className={getCls('skeletonLeftWrap')}>
                        <div className={getCls('SkeletonAvatar')} />
                        <div className={getCls('skeletonInfo')}>
                            <div className={getCls('skeletonTitle')} />
                            <div className={getCls('skeletonTitle')} />
                        </div>
                    </div>
                    <div className={getCls('skeletonRightWrap')}>
                        <div />
                    </div>
                </div>);
            })
        }
    </>);
};

// eslint-disable-next-line max-statements
export default function ShareInvite(props: IShareInviteProps) {
    const intl = useIntl();
    const {
        className,
        title,
        backMergeModal,
        onAdded,
        showCancel = false,
        showClose = false,
        hideDepartmentItem = false,
        handleClose,
        docGuid,
        repository,
        curDepartment,
        // showPowerList,
        powerListOptions,
        powerValue,
        powerListClassName,
        shareInviteConfig,
        memberInfoMaxWidth,
        userGuid,
        changeOptionsList,
        changePowerValue,
        shareContent,
        externalShareMethod,
        version,
        filterUser,
        isSearchSensitiveUser = false,
        onConfirm,
        memberList,
        isSearchExternalUser = false,
    } = props;
    const isDocs = shareInviteConfig.source === ShareInviteModalSource.docs;
    const isShow = shareInviteConfig.type === ShareInviteModalType.show;
    const isRecentDocs = shareInviteConfig.source === ShareInviteModalSource.recentDocs;
    const isDepartment = shareInviteConfig.source === ShareInviteModalSource.department;
    const isRepository = shareInviteConfig.source === ShareInviteModalSource.repository;
    const isPersonalPage = shareInviteConfig.source === ShareInviteModalSource.personalPage;
    const isShare = shareInviteConfig.type === ShareInviteModalType.share;
    const isInvite = shareInviteConfig.type === ShareInviteModalType.invite || isShow;
    const isModal = shareInviteConfig.displayType === shareInviteDisplayType.modal;
    const isRepositoryPublic = repository?.scope === RepositoryScope.SpaceReader;
    // 是否展示底部赋权
    // FIXME: 赋权逻辑server有问题暂时关闭赋权入口
    const defaultShowEmpowerment = isShare && isDocs && !isRepositoryPublic &&
        (curDocCanInviteAdmin() || curDocCanInviteReader() || curDocCanInviteEditor());
    const [showEmpowerment, setShowEmpowerment] = useState(defaultShowEmpowerment);
    // const defaultShowEmpowerment = false;
    // 展示下拉赋权
    const showPowerList = isInvite;
    // 禁用输入框的下拉赋权
    const powerDisabled = false;

    // 是否绑定如流
    const isRuLiu = curUserHaveRlId();
    // 远程数据
    const [listData, setListData] = useState<Iitems[]>([]); // 最近
    const inputRef = useRef<HTMLInputElement>(null);
    // 选中的sug
    const [sugListData, setSugListData] = useState<Iitems[]>(memberList || []);
    // 是否勾选赋权
    const [handleEmpowerment, setHandleEmpowerment] = useState(
        showEmpowerment && powerListOptions?.length
    );
    // 输入框下拉赋权选项
    const [selectRoleName, setSelectRoleName] = useState(powerValue || '');
    // 骨架屏loading，输入检索时出现
    const [loadingStatus, setLoadingStatus] = useState(false);

    const [recentlyTitle, setRecentlyTitle] = useState(false);

    const [shareForInvite, setShareForInvite] = useState(false);

    const [showRecent, setShowRecent] = useState(false);

    // 获取推荐群信息
    const [recommendGroup, setRecommendGroup] = useState<any[]>([]);
    const [recommendGroupState, setRecommendGroupState] = useState(true);

    // 输入框值
    const [inputs, setInputs] = useState('');
    const [listDataStatus, setListDataStatus] = useState('');
    const [loading, setLoading] = useState(false);

    const docAdmin = store.getCurDocument()?.docRoleName === 'DocAdmin';
    const docMember = store.getCurDocument()?.docRoleName === 'DocMember';
    // 部门列表
    const [deptMsg, setDeptMsg] = useState<Iitems[]>([{
        nickname: '',
        groupGuid: '',
        spaceGuid: '',
        isAdded: false,
        roleName: '',
        isDept: true,
        email: '部门全员',
        randomId: '',
        userGuid: '',
        isHandle: false,
    }]);
    let alreadySuccess: any = null;
    let num = 0;

    useEffect(() => {
        async function getDocsBelongDepts() {
            if (isRepository) {
                const params = {
                    spaceGuid: repository?.spaceGuid,
                    groupGuid: repository?.groupGuid,
                    repositoryGuid: repository?.repositoryGuid,
                };
                const res = await sdk.as.getAuthenticRightDepts(params);
                if (res && Object.keys(res).length) {
                    setDeptMsg([{
                        ...deptMsg[0],
                        nickname: res?.certainGroup?.groupName,
                        groupGuid: res?.certainGroup?.groupGuid,
                        spaceGuid: res?.certainGroup?.spaceGuid,
                        isAdded: res?.certainGroup?.added,
                        roleName: res?.certainGroup?.roleName,
                        userGuid: res?.certainGroup?.groupGuid,
                        isHandle: res?.certainGroup?.canManage,
                    }]);
                }
            } else if (isDocs) {
                const ksServer = await sdk.getKsServer(repository);
                const curDocument = store.getCurDocument();
                const params = {
                    repositoryGuid: curDocument?.repositoryGuid,
                    docGuid: curDocument?.docGuid,
                };
                const res = await ksServer.getDocBelongsDepts(params);
                if (res && Object.keys(res).length) {
                    setDeptMsg([{
                        ...deptMsg[0],
                        nickname: res?.certainGroup?.groupName,
                        groupGuid: res?.certainGroup?.groupGuid,
                        spaceGuid: res?.certainGroup?.spaceGuid,
                        isAdded: res?.certainGroup?.added,
                        roleName: res?.certainGroup?.roleName,
                        userGuid: res?.certainGroup?.groupGuid,
                        isHandle: res?.certainGroup?.canManage,
                    }]);
                }
            }
        }
        getDocsBelongDepts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function prompt(flag: boolean, type: any, content: any, elseContent: any) {
        if (num === 1) {
            toast({
                type: type,
                content: content,
            });
        } else if (num === 2 && typeof alreadySuccess === 'boolean' && alreadySuccess === flag) {
            toast({
                type: type,
                content: elseContent,
            });
        }
    }

    function isSuccess(val: any) {
        const flag = typeof alreadySuccess === 'boolean';
        if (num === 2) {
            alreadySuccess = flag ? null : val;
            num = flag ? 0 : num;
            return '';
        }
        num = 0;
    }

    // 分享邀请按钮禁用
    function shareInviteBtnDisabled() {
        // sug 为空
        const isNoSug = !sugListData.length;
        if (isShow) {
            return false;
        }
        // // 需要赋权验证
        // const sharePage = isShare && !isDepartment;
        // const noAuth = sugListData.some((item: Iitems) => !item.roleName && !item.rocRoleName);
        // // 有需要被赋权的人 但没有勾选
        // const isMustEmpowerment = sharePage && !handleEmpowerment && noAuth;
        // return isNoSug || isMustEmpowerment;
        // pm确认 勾不勾选都能分享
        return isNoSug;
    }

    // 返回一层弹窗 || 关闭弹窗
    const handleCancel = useCallback((isClose?: boolean) => {
        if (isDocs && isModal && isClose) {
            handleClose && handleClose();
            return;
        }
        isDocs && backMergeModal && backMergeModal();
        !isDocs && handleClose && handleClose();
    }, [backMergeModal, handleClose, isDocs, isModal]);

    // 匹配
    function isMatch(item: Iitems, itemData: Iitems) {
        const isFindUserGuide = itemData?.userGuid && itemData.userGuid === item.userGuid;
        const isFindUserGid = itemData?.gid && itemData.gid === item.gid;
        const isEmailGroup = itemData?.emailGroupAddress && itemData.emailGroupAddress === item?.emailGroupAddress;
        return isFindUserGuide || isEmailGroup || isFindUserGid;
    }

    // 点击多选框的选中态
    const handleCheckBoxUpdateList = useCallback((listData: Iitems[], itemData: Iitems, checked: boolean) => {
        return listData.map((item: Iitems) => {
            /*
                1.点的这项没有childrenMember（也就是群，一层用户和群成员没有childrenMember）: 否则核对id
                2.哪个有childrenMember，哪个走递归
            */
            if (!itemData.childrenMember && item.childrenMember) {
                handleCheckBoxUpdateList(item.childrenMember, itemData, checked);
                return item;
            } else {
                if (isMatch(item, itemData)) {
                    item.checked = checked;
                }
                return item;
            }
        });
    }, []);

    // 更新list选中态
    const handleOpenUpdateList = useCallback((listDataData: Iitems[], checked: boolean) => {
        return listDataData.map((item: Iitems) => {
            // 群成员加上唯一id
            item.randomId = uniqueId('random_');
            const isFind = sugListData.some(((sug: Iitems) => isMatch(item, sug)));
            if (isFind) {
                item.checked = checked;
            } // 展开时sugList有就选中
            return item;
        });
    }, [sugListData]);

    // 远程搜索数据,搜索结果跟sugs比对
    const getListDataChange = useCallback((result: Iitems[]) => {
        setListData(handleOpenUpdateList(result, true));
    }, [handleOpenUpdateList]);

    // 是否有添加部门内权限
    // 选中部⻔后权限选择上仅可选择只读成员(包含同时添加了其他人、群、邮件组等)
    function getExistDept(arr: any[]) {
        if (!powerListOptions || !!powerListOptions.length) {
            return;
        }
        let isExistDept = false;
        arr.forEach(item => {
            if (item?.isDept) {
                isExistDept = true;
            }
        });
        if (isExistDept) {
            if (isRepository) {
                powerListOptions[0].disabled = true;
                powerListOptions[1].disabled = true;
                changeOptionsList && changeOptionsList(powerListOptions);
                changePowerValue && changePowerValue(Role.Reader);
            } else if (isDocs) {
                powerListOptions[0].disabled = true;
                powerListOptions[1].disabled = !docAdmin;
                powerListOptions[2].disabled = !(docAdmin || docMember);
                changeOptionsList && changeOptionsList(powerListOptions);
                changePowerValue && changePowerValue(DocRole.Reader);
            }
        } else {
            // eslint-disable-next-line no-lonely-if
            if (isRepository) {
                powerListOptions[0].disabled = !isAdminRepository();
                powerListOptions[1].disabled = !curUserRepositoryInviteMember();
                changeOptionsList && changeOptionsList(powerListOptions);
                changePowerValue && changePowerValue((isAdminRepository() ? Role.Member : Role.Reader));
            } else if (isDocs) {
                powerListOptions[0].disabled = !curDocCanInviteAdmin();
                powerListOptions[1].disabled = !curDocCanInviteEditor();
                powerListOptions[2].disabled = !curDocCanInviteReader();
                changeOptionsList && changeOptionsList(powerListOptions);
            }
        }
    }

    // 删除方法
    const delSugs = useCallback((sugList: Iitems[], itemData: Iitems) => {
        return sugList.filter((item: Iitems) => !isMatch(item, itemData));
    }, []);
    // 删除删除sug
    const handelDelSug = useCallback((itemData: Iitems) => {
        return () => {
            setSugListData(delSugs(sugListData, itemData));
            setListData(handleCheckBoxUpdateList(listData, itemData, false));
            setDeptMsg(handleCheckBoxUpdateList(deptMsg, itemData, false));
            getExistDept(delSugs(sugListData, itemData));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [delSugs, handleCheckBoxUpdateList, listData, sugListData, deptMsg]);

    // 点击多选框
    function handleCheckBox(itemData: Iitems, checked: boolean, index: string) {
        if (checked && (itemData.virtualUser || 'isClosed' in itemData || itemData?.isVirtualUser)) {
            toast({
                content: '注意：添加智能体账号后，该账号可读取其有权限的文档内容。',
                type: ToastType.Warning,
                duration: 3000,
            });
        }
        if (checked && showEmpowerment && powerListOptions?.length) {
            clickShareBtnLog();
        }
        if (sugListData.length >= MAX_SUGS_NUM) {
            toast({content: '已达人数上限', type: ToastType.Error});
            return;
        }
        const MemberType: {[key in string]: string} = {5: 'user', 10: 'group', 15: 'mg'};
        const type: any = itemData?.memberType || '';
        feLogger(searchClickScene({
            position: isShare ? 'share' : 'add',
            sort: index,
            type: type ? MemberType[type] : '',
        }));
        setListData(handleCheckBoxUpdateList(listData, itemData, checked));
        setDeptMsg(handleCheckBoxUpdateList(deptMsg, itemData, checked));
        // 当前点击的在不在sug里
        const isFind = sugListData.some((item: Iitems) => isMatch(item, itemData));
        if (itemData.isExternalUser && shareForInvite && checked) {
            toast({
                content: '外部员工不会接收到如流通知',
                type: ToastType.Error,
            });
        }
        // sug已有 && 取消操作
        if (isFind && !checked) {
            setSugListData(delSugs(sugListData, itemData)); // 删掉已有的sug
            getExistDept(delSugs(sugListData, itemData));
        } else {
            setSugListData([...sugListData, itemData]); // 新增一个
            getExistDept([...sugListData, itemData]);
            if (itemData?.isDept) {
                toast({
                    content: <>
                        <Icon svg={InfoSvg} size={IconSize.LG} />
                        <span className={styles.permissionSentence}>为保证信息安全，权限选择范围已发生变化</span>
                    </>,
                    type: ToastType.Info,
                    className: styles.permissionsTips,
                });
            }
        }
        // 用户点击后选中输入框输入的文字
        // setAutoSelectInput(true);
        inputRef.current?.select();
    }

    // 获取群成员
    async function getGroupItems(itemData: any) {
        try {
            let result = [];
            if (isDocs) {
                const curDocument = store.getCurDocument();
                result = await sdk.as.getMemberList(
                    itemData?.gid,
                    curDocument?.spaceGuid,
                    curDocument?.repositoryGuid,
                    docGuid,
                    sdk.as.user?.rlId,
                    repository?.groupGuid
                );
            } else if (isRepository || isRecentDocs) {
                result = await sdk.as.getMemberList(
                    itemData?.gid,
                    repository?.spaceGuid,
                    repository?.repositoryGuid,
                    isRecentDocs ? docGuid : '',
                    sdk.as.user?.rlId,
                    repository?.groupGuid
                );
            } else if (isDepartment) {
                result = await sdk.as.getMemberList(
                    itemData?.gid,
                    curDepartment?.spaceGuid,
                    '',
                    '',
                    sdk.as.user?.rlId,
                    curDepartment?.groupGuid
                );
            }
            return result;
        } catch (error) {
            console.error(error);
            return [];
        }
    }
    // 展开群成员
    async function handleClickGroupBtn(itemData: Iitems, openStatus: boolean) {
        try {
            // 发请求：当前项没有childrenMember && 点了open
            // 否则使用缓存
            setLoading(true);
            const needAjax = !itemData.childrenMember && openStatus;
            const needData = needAjax ? await getGroupItems(itemData) : itemData.childrenMember;
            const result = needData;
            // 塞入children
            const childrenMemberObj = {
                childrenMember: handleOpenUpdateList(result, true),
                openChildStatus: openStatus,
            };
            setListData(listData.map(item => {
                return item.gid === itemData.gid ? Object.assign(item, childrenMemberObj) : item;
            }));
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }
    // 选了下拉赋权
    const onPowerChange = useCallback((roleName: string) => {
        setSelectRoleName(roleName || '');
        changePowerValue && changePowerValue(roleName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // 选了底部赋权
    const handleChangeEmpowerment = useCallback((ev: any) => {
        setHandleEmpowerment(ev.target.checked);
    }, []);

    // 成功的回调
    function performHooks(roleName?: string) {
        onAdded && onAdded(roleName);
    }

    // 分享接口users参数
    function transformShareAPIParams(users: SinglePersonData[]) {
        return users.map(item => {
            if (item.memberType === MemberType.RlGroup) {
                return {
                    gid: item.gid,
                    name: item.name,
                    isSensitive: !!item?.isSensitive,
                };
            } else {
                if (item.virtualUser || 'isClosed' in item || item?.isVirtualUser) {
                    item.avatar = '';
                }
                return {
                    rlId: item.rlId,
                    avatar: item.avatar,
                    isSensitive: !!item?.isSensitive,
                };
            }
        });
    }

    // 知识库文档分享方法
    async function handleShareDocsRepository(sugList: SinglePersonData[]) {
        // 文档的分享赋权，群和邮件组不能禁止赋予文档管理员权限
        if (selectRoleName === DocRole.DocAdmin && isDocs && handleEmpowerment) {
            const groupOrEmail = sugList.filter(item => {
                return item.memberType === (MemberType.RlGroup || MemberType.EmailGroup);
            });
            const isExternalUser = sugList.some(item => item.isExternalUser);
            if (isExternalUser) {
                toast({content: '群/邮件组/外部员工无法设置为管理员，请删除后再试', type: ToastType.Error});
                return;
            }
            if (groupOrEmail.length) {
                toast({content: '群/邮件组无法设置为管理员，请删除后再试', type: ToastType.Error});
                return;
            }
        }
        const users = transformShareAPIParams(sugList);

        try {
            const res = await shareToRuLiu(
                users, repository, docGuid, intl, handleEmpowerment && selectRoleName, shareContent, version
            );
            if (res) {
                handleClose && handleClose();
                toast({
                    content: intl.formatMessage({id: 'toastShareSuccess'}),
                    type: ToastType.Success,
                }).catch(err => {
                    console.log(err);
                });
                const publicParams = {
                    type: docGuid ?
                        (window.location.href.includes(docGuid) ?
                            ShareSource[`${getPageType()}`]
                            : ShareSource.recent)
                        : ShareSource.repository,
                };
                const docParams = handleEmpowerment ? {
                    card: +handleEmpowerment,
                    permission: MemberPermission[selectRoleName],
                } : {
                    card: +handleEmpowerment,
                };
                feLogger(shareCardToRuLiu(docGuid ? {...docParams, ...publicParams} : publicParams));
                feLogger(docShareInvite(EnumShareInviteType.share, users.length));
            }
        } catch (error) {
            toast({
                content: intl.formatMessage({id: 'toastShareFailed'}),
                type: ToastType.Error,
            });
        }
    }

    // 部门分享方法
    async function handleShareDepartment(users: SinglePersonData[]) {
        feLogger(shareDepartment);
        try {
            assert(curDepartment);
            const {spaceGuid = '', groupGuid = ''} = curDepartment;
            const thumb = sdk.as.getDepLogoUploadUrl(spaceGuid, groupGuid, +new Date());
            await sdk.as.shareDepartment(spaceGuid, groupGuid, users, thumb, location.href);
            // const ref = sharePopperRef?.current;
            // ref && ref.setVisible(false);
            toast({
                content: intl.formatMessage({id: 'toastShareSuccess'}),
                type: ToastType.Success,
            }).catch(err => {
                console.log(err);
            });
            handleCancel();
            feLogger(shareCardToRuLiu({
                type: ShareSource.department,
                page_id: docGuid,
                kb_id: repository?.repositoryGuid || '',
                kb_org_id: repository?.groupGuid || '',
            }));
            feLogger(clickShareModalBtn(PageType.department, {groupId: curDepartment?.groupGuid}));
        } catch (err) {
            toast({
                content: intl.formatMessage({id: 'toastShareFailed'}),
                type: ToastType.Error,
            });
        }
    }

    // 个人主页分享方法
    const handleSharePersonalPage = useCallback(async (users: SinglePersonData[]) => {
        // feLogger(shareDepartment);
        try {
            await sdk.as.sharePersonalPage({
                shareUserGuid: userGuid || '',
                shareMembers: users.map((user) => {
                    const data: any = {
                        avatar: user.memberType === MemberType.RlGroup ? '' : (user.avatar || ''),
                        gid: `${user.gid || user.rlId}` || '',
                    };
                    if (user.memberType === MemberType.RlGroup) {
                        data.name = user.name;
                    }
                    return data;
                }),
            });
            toast({
                content: intl.formatMessage({id: 'toastShareSuccess'}),
                type: ToastType.Success,
            }).catch(err => {
                console.log(err);
            });
            handleCancel();
            // feLogger(shareCardToRuLiu({
            //     type: ShareSource.department,
            // }));
            // feLogger(clickShareModalBtn(PageType.department, {groupId: curDepartment?.groupGuid}));
        } catch (err) {
            toast({
                content: intl.formatMessage({id: 'toastShareFailed'}),
                type: ToastType.Error,
            });
        }
    }, [handleCancel, intl, userGuid]);

    // 点击分享按钮
    function handleShareBtn() {
        isDepartment && handleShareDepartment(sugListData);
        isPersonalPage && handleSharePersonalPage(sugListData);
        !isDepartment && !isPersonalPage && handleShareDocsRepository(sugListData);
    }

    // selectRoleName 当前下拉赋权选项
    // 部门邀请
    function handleInviteDepartment(users: SinglePersonData[]) {
        let haveGroup = false;
        const members = users.map(({memberType, userGuid, nickname, gid, name, emailGroupAddress}) => {
            if (memberType === MemberType.RlGroup || memberType === MemberType.EmailGroup) {
                haveGroup = true;
            }
            return {
                memberType,
                memberGuid: userGuid || gid || emailGroupAddress,
                nickname: nickname || name || emailGroupAddress,
            };
        });
        const isExternalUser = users.some(item => item.isExternalUser);
        if (isExternalUser && [Role.Admin, Role.Owner, Role.DocAdmin].includes(selectRoleName)) {
            toast({content: '群/邮件组/外部员工无法设置为管理员，请删除后再试', type: ToastType.Error});
            return;
        }
        if (haveGroup) {
            if (DepartmentRole.AAOwner === selectRoleName) {
                toast({
                    type: ToastType.Error,
                    content: `群/邮件组无法设置为${banJurisdiction.AAOwner}，请删除后再试`,
                });
                return;
            } else if (DepartmentRole.Admin === selectRoleName) {
                toast({
                    type: ToastType.Error,
                    content: `群/邮件组无法设置为${banJurisdiction.Admin}，请删除后再试`,
                });
                return;
            }
        }
        assert(curDepartment);
        const {spaceGuid = '', groupGuid = ''} = curDepartment;
        const data = {
            members,
            roleName: selectRoleName,
            action: 'invite',
            message: '',
        };
        sdk.as.operateDepartmentMember(
            data,
            {
                spaceGuid: spaceGuid,
                groupGuid: groupGuid,
            }
        ).then(async () => {
            if (shareForInvite) {
                try {
                    const thumb = sdk.as.getDepLogoUploadUrl(spaceGuid, groupGuid, +new Date());
                    await sdk.as.shareDepartment(spaceGuid, groupGuid, users, thumb, location.href);
                } catch (error) {
                    toast({type: ToastType.Error, content: intl.formatMessage({id: 'addMemberSuccessShareFailed'})});
                    performHooks();
                    return;
                }
            }
            toast({
                type: ToastType.Success,
                content: intl.formatMessage({id: 'addMemberSuccess'}),
            });
            performHooks();
        }).catch(() => {
            toast({
                type: ToastType.Error,
                content: intl.formatMessage({id: 'addMemberFailed'}),
            });
        });
    }

    async function handleShareToRuLiuForInvite(users: SinglePersonData[]) {
        const isUserAvatar = isPersonal(repository) && repository?.userGuid;
        const logoSrc = isUserAvatar
            ? concatImgSrc(repository?.userGuid)
            : concatImgSrc('',
                repository?.spaceGuid,
                repository?.groupGuid,
                repository?.repositoryGuid,
                Date.now()
            );
        try {
            await sdk.as.share({
                url: window.location.href,
                users: transformShareAPIParams(users),
                spaceGuid: repository?.spaceGuid,
                repositoryGuid: repository?.repositoryGuid,
                groupGuid: repository?.groupGuid,
                docGuid: docGuid,
                thumb: logoSrc,
                roleName: false,
            });
            return true;
        } catch (error) {
            return false;
        }
    }

    // 知识库邀请
    async function handleInviteRepository(users: SinglePersonData[]) {
        //  点击确定  确定添加
        let isHaveGroup = false;
        const data = users.map(val => {
            if (val.memberType === MemberType.RlGroup || val.memberType === MemberType.EmailGroup) {
                isHaveGroup = true;
            }
            if (val.memberType === MemberType.User) {
                return {
                    nickname: val.nickname,
                    memberType: val.memberType,
                    memberGuid: val.userGuid,
                    isSensitive: !!val?.isSensitive,
                };
            } else if (val.memberType === MemberType.EmailGroup) {
                return {
                    nickname: val.emailGroupAddress,
                    memberType: val.memberType,
                    memberGuid: val.emailGroupAddress,
                    isSensitive: !!val?.isSensitive,
                };
            } else {
                return {
                    nickname: val.name || val.nickname,
                    memberType: val.memberType,
                    memberGuid: val.gid ? val.gid : val.memberGuid,
                    isSensitive: !!val?.isSensitive,
                };
            }
        });
        const isExternalUser = users.some(item => item.isExternalUser);
        if (isExternalUser && [Role.Admin, Role.Owner].includes(selectRoleName)) {
            toast({content: '群/邮件组/外部员工无法设置为管理员，请删除后再试', type: ToastType.Error});
            return;
        }
        if (isHaveGroup && [Role.Admin, Role.Owner].includes(selectRoleName)) {
            toast({content: '群/邮件组无法设置为管理员，请删除后再试', type: ToastType.Error});
            return;
        }
        sdk.as.addPerson(repository, {
            members: data,
            roleName: selectRoleName,
            action: 'invite',
            message: '',
        }).then(async () => {
            if (shareForInvite) {
                const res = await handleShareToRuLiuForInvite(users);
                if (!res) {
                    toast({
                        content: intl.formatMessage({id: 'addMemberSuccessShareFailed'}),
                        type: ToastType.Error,
                    });
                    performHooks(selectRoleName);
                    return;
                }
            }
            prompt(true, ToastType.Success, '添加成员成功', '添加成功');
            performHooks(selectRoleName);
            isSuccess(true);
        }).catch((error: any) => {
            const isExternalUser = users.some(item => item.isExternalUser);
            if (isExternalUser && [Role.Admin, Role.Owner].includes(selectRoleName)) {
                toast({content: '群/邮件组/外部员工无法设置为管理员，请删除后再试', type: ToastType.Error});
                isSuccess(false);
                return;
            }
            if (error.externCode === 'ErrorRlGroupCannotAssignAdmin') {
                toast({content: '群/邮件组无法设置为管理员，请删除后再试', type: ToastType.Error});
            }
            else if (error.code === ErrorCode.AdministratorLimit) {
                toast({content: error.message, type: ToastType.Error});
            }
            else {
                // toast({content: intl.formatMessage({id: 'addMemberFailed'}), type: ToastType.Error});
                prompt(false, ToastType.Error, '添加成员失败', '添加失败');
            }
            isSuccess(false);
        });
    }

    // 文档邀请
    async function handleInviteDocs(users: SinglePersonData[]) {
        const newAdd = users.filter(val => {
            return !val.rocRoleName;
        });
        const againUpdate = users.filter(val => {
            return val.rocRoleName;
        });
        let isHaveGroup = false;
        const newAddData = newAdd.map(val => {
            const isSensitive = !!val?.isSensitive;
            if (val.memberType === MemberType.RlGroup || val.memberType === MemberType.EmailGroup) {
                isHaveGroup = true;
            }
            // 最近@人列表获取不到memberType，但是有userGuide
            if (!val?.memberType && val.userGuid) {
                return {
                    nickname: val.name || val.nickname,
                    memberType: MemberType.User,
                    memberGuid: val.userGuid || val.memberGuid,
                    isSensitive: isSensitive,
                };
            }
            if (val.memberType === MemberType.User) {
                return {
                    nickname: val.nickname,
                    memberType: val.memberType,
                    memberGuid: val.userGuid || val.memberGuid,
                    isSensitive: isSensitive,
                };
            } else if (val.memberType === MemberType.EmailGroup) {
                return {
                    nickname: val.emailGroupAddress,
                    memberType: val.memberType,
                    memberGuid: val.emailGroupAddress,
                    isSensitive: isSensitive,
                };
            } else {
                return {
                    nickname: val.name || val.nickname,
                    memberType: val.memberType,
                    memberGuid: val.gid ? val.gid : val.memberGuid,
                    isSensitive: isSensitive,
                };
            }
        });
        const againUpdateData = againUpdate.map(val => {
            const isSensitive = !!val?.isSensitive;
            if (val.memberType === MemberType.User) {
                return {
                    nickname: val.nickname,
                    memberType: val.memberType,
                    memberGuid: val.userGuid || val.memberGuid,
                    isSensitive: isSensitive,
                };
            } else if (val.memberType === MemberType.EmailGroup) {
                return {
                    nickname: val.emailGroupAddress,
                    memberType: val.memberType,
                    memberGuid: val.emailGroupAddress,
                    isSensitive: isSensitive,
                };
            } else {
                return {
                    nickname: val.name || val.nickname,
                    memberType: val.memberType,
                    memberGuid: val.gid ? val.gid : val.memberGuid,
                    isSensitive: isSensitive,
                };
            }
        });
        const isExternalUser = users.some(item => item.isExternalUser);
        if (isExternalUser && DocRole.DocAdmin === selectRoleName) {
            toast({content: '群/邮件组/外部员工无法设置为管理员，请删除后再试', type: ToastType.Error});
            return;
        }
        if (selectRoleName === DocRole.DocAdmin && isHaveGroup) {
            toast({content: '群/邮件组不可添加为页面管理员', type: ToastType.Error});
            return;
        }
        try {
            const ksServer = await sdk.getKsServer(repository);
            newAddData.length && await ksServer.inviteJoin(
                docGuid,
                {
                    members: newAddData,
                    roleName: selectRoleName,
                    action: 'invite',
                    message: '',
                });
            againUpdateData.length && await ksServer.inviteJoin(
                docGuid,
                {
                    members: againUpdateData,
                    roleName: selectRoleName,
                    action: 'change',
                    message: '',
                }
            );
            if (shareForInvite) {
                const res = await handleShareToRuLiuForInvite(users);
                if (!res) {
                    toast({
                        content: intl.formatMessage({id: 'addMemberSuccessShareFailed'}),
                        type: ToastType.Error,
                    });
                    performHooks();
                    feLogger(docShareInvite(EnumShareInviteType.invite, newAddData.length + againUpdateData.length));
                    return;
                }
            }
            // toast({content: intl.formatMessage({id: 'addMemberSuccess'}), type: ToastType.Success});
            prompt(true, ToastType.Success, '添加成员成功', '添加成功');
            performHooks();
            feLogger(addMember({
                type: DocType[`${getPageType()}`],
                card: shareForInvite ? 1 : 0, // 0未勾选分享到如流 1已勾选
                permission: MemberPermission[selectRoleName],
            }));
            feLogger(docShareInvite(EnumShareInviteType.invite, newAddData.length + againUpdateData.length));
            isSuccess(true);
        } catch (error) {
            // toast({content: intl.formatMessage({id: 'addMemberFailed'}), type: ToastType.Error});
            prompt(false, ToastType.Error, '添加成员失败', '添加失败');
            isSuccess(false);
        }
    }

    // 知识库添加至部门内公开
    async function handleAddRepositoryInDept(value: any) {
        const params = {
            spaceGuid: deptMsg[0]?.spaceGuid,
            groupGuid: deptMsg[0]?.groupGuid,
            repositoryGuid: repository?.repositoryGuid,
        };
        const data = {
            action: 'invite',
            roleName: Role.Reader,
            message: '',
            members: [{
                memberGuid: deptMsg[0]?.groupGuid || '',
                memberType: 20,
                nickname: '',
                alias: '',
            }],
        };
        try {
            if (selectRoleName !== Role.Reader) {
                toast({content: '仅可添加部门为只读成员，请重试', type: ToastType.Error});
                return;
            }
            await sdk.as.addRepositoryInDept(params, data);
            prompt(true, ToastType.Success, '添加部门成功', '添加成功');
            feLogger(permissionsOpenDept({source: 1}));
            performHooks();
            isSuccess(true);
        } catch (error) {
            console.log(error, 'error');
            prompt(false, ToastType.Error, '添加部门失败', '添加失败');
            performHooks();
            isSuccess(false);
        }
    }

    // 修改文档、知识本公开至部门权限
    async function changeDeptPower() {
        try {
            if (selectRoleName === Role.DocAdmin) {
                toast({content: '仅可添加部门为可阅读/可编辑权限，请重试', type: ToastType.Error});
                return;
            }
            const curDocument = store.getCurDocument();
            const ksServer = await sdk.getKsServer(repository);
            const params = {
                docGuid: curDocument?.docGuid,
                repositoryGuid: curDocument?.repositoryGuid,
                memberGuid: deptMsg[0]?.groupGuid,
            };
            const data = {
                action: 'change',
                roleName: selectRoleName,
            };
            await ksServer.changeDocBelongsInDepts(params, data);
            prompt(true, ToastType.Success, '添加部门成功', '添加成功');
            performHooks();
            isSuccess(true);
        } catch (error) {
            console.log(error, 'error');
            prompt(false, ToastType.Error, '添加部门失败', '添加失败');
            performHooks();
            isSuccess(false);
        }
    }

    // 知识本、文档添加至部门内公开
    async function handleAddDocInDept(value: any) {
        try {
            if (selectRoleName === Role.DocAdmin) {
                toast({content: '仅可添加部门为可阅读/可编辑权限，请重试', type: ToastType.Error});
                return;
            }
            const ksServer = await sdk.getKsServer(repository);
            const curDocument = store.getCurDocument();
            const params = {
                repositoryGuid: curDocument?.repositoryGuid,
                docGuid: curDocument?.docGuid,
            };
            const data = {
                action: 'invite',
                roleName: selectRoleName,
                message: '',
                members: [{
                    memberGuid: deptMsg[0]?.groupGuid || '',
                    memberType: 20,
                    nickname: '',
                    alias: '',
                }],
            };
            await ksServer.addDocBelongsInDepts(params, data);
            prompt(true, ToastType.Success, '添加部门成功', '添加成功');
            if (curDocument?.type === 2) {
                feLogger(permissionsOpenDept({source: 2}));
            } else {
                feLogger(permissionsOpenDept({source: 3}));
            }
            performHooks();
            isSuccess(true);
        } catch (error) {
            console.log(error, 'error');
            prompt(false, ToastType.Error, '添加部门失败', '添加失败');
            performHooks();
            isSuccess(false);
        }
    }

    // 点击邀请
    function handleInviteBtn() {
        if (onConfirm) {
            onConfirm && onConfirm(sugListData, powerValue || '');
            backMergeModal && backMergeModal();
            return;
        }
        const deptGroup: Iitems[] = [];
        const elseGroup: Iitems[] = [];
        if (sugListData) {
            sugListData.forEach(item => {
                if (item?.isDept) {
                    deptGroup.push(item);
                } else {
                    elseGroup.push(item);
                }
            });
        }
        if (elseGroup.length) {
            if (isDocs) {
                handleInviteDocs(elseGroup);
                num++;
            }
            if (isRepository) {
                handleInviteRepository(elseGroup);
                num++;
            }
            isDepartment && handleInviteDepartment(elseGroup);
        }
        if (deptGroup.length) {
            if (isRepository) {
                handleAddRepositoryInDept(deptGroup);
                num++;
            }
            if (isDocs) {
                // eslint-disable-next-line no-negated-condition
                if (!deptMsg[0]?.roleName) {
                    handleAddDocInDept(deptGroup);
                } else {
                    changeDeptPower();
                }
                num++;
            }
        }
    }

    // 点击分享或邀请
    const handleShareInvite = throttle(() => {
        if (externalShareMethod) {
            externalShareMethod(sugListData);
            return;
        }
        isShare && handleShareBtn();
        isInvite && handleInviteBtn();
    }, 1200, {leading: true, trailing: false});

    // 获取最近列表
    const getMentionsList = useCallback(async () => {
        try {
            setLoading(true);
            setRecentlyTitle(true);
            const curDocument = store.getCurDocument();
            const spaceGuid = isDepartment ? curDepartment?.spaceGuid : repository?.spaceGuid;
            const groupGuid = isDepartment ? curDepartment?.groupGuid : repository?.groupGuid;
            const params = {
                spaceGuid,
                groupGuid,
                repositoryGuid: repository?.repositoryGuid,
                docGuid,
                type: isShow ? ShareInviteModalType.invite : shareInviteConfig.type,
                source: shareInviteConfig.source === ShareInviteModalSource.recentDocs
                    ? ShareInviteModalSource.docs : shareInviteConfig.source,
                excludeNotInherit: curDocument?.inheritRepo === InheritRepo.Not_Inherit,
            };
            let resultData = await sdk.as.getRecentlyList(params);
            if (resultData.length && filterUser) {
                resultData = resultData.filter((item: {userGuid: any}) => item.userGuid !== filterUser);
            }
            // 知识本下文档获取知识本权限
            if (docGuid && resultData.length &&
                 curDocument?.bookType === BOOK_TYPE.IN_BOOK &&
                   curDocument?.rootGuid) {
                let directoryRoleList: any = [];
                const directoryRoleParams = resultData.map((val: SinglePersonData) => {
                    if (val.memberType === MemberType.User) {
                        return val.userGuid;
                    } else if (val.memberType === MemberType.EmailGroup) {
                        return val.emailGroupAddress;
                    } else {
                        return val.gid;
                    }
                }).join(',');
                const ksServer = await sdk.getKsServer(repository);
                directoryRoleList = await ksServer.getHavePowerPerson(curDocument?.rootGuid, directoryRoleParams);
                resultData = resultData.map((member: SinglePersonData) => {
                    const directoryRoleName = getRoleName(member, directoryRoleList);
                    return {
                        ...member,
                        directoryRoleName,
                    };
                });
            }
            if (resultData?.length) {
                setListDataStatus('');
            } else {
                setListDataStatus(STATUS.noData);
            }
            getListDataChange(resultData);
            setLoading(false);
        } catch (error) {
            setListDataStatus(STATUS.error);
            setLoading(false);
        }
    }, [curDepartment, docGuid, getListDataChange, isDepartment, repository, shareInviteConfig, filterUser, isShow]);

    // 获取搜索数据
    const getSearchData = useCallback(async (value: string): Promise<any> => {
        try {
            const curDocument = store.getCurDocument();
            const isShowVirtualList = true; // 是否展示虚拟用户列表，默认不展示
            const res: any = isDepartment ?
                await departmentOnSearch(
                    value,
                    curDepartment?.spaceGuid,
                    curDepartment?.groupGuid,
                    isShare,
                    true
                ) :
                await onSearch(
                    value,
                    isPersonalPage ? undefined : repository,
                    docGuid,
                    isShare,
                    curDocument,
                    isSearchSensitiveUser,
                    isShowVirtualList,
                    isInvite ? isSearchExternalUser : false
                );
            if (filterUser) {
                return res.result.filter((item: { userGuid: string }) => item.userGuid !== filterUser);
            } else {
                const resultData = res.result;
                return resultData;
            }
        } catch (error: any) {
            return new Error(error);
        }
    }, [isDepartment,
        curDepartment?.spaceGuid,
        curDepartment?.groupGuid,
        isShare, isPersonalPage,
        repository, docGuid,
        isSearchSensitiveUser,
        filterUser,
        isSearchExternalUser,
        isInvite]);

    // 输入框改变
    const inputsChange = useCallback(async (inputVal: string) => {
        loading && setLoading(false);
        setLoadingStatus(true);
        setInputs(inputVal);
        setListData([]);
        setRecentlyTitle(false);
        if (!inputVal) {
            // UPGRADE: 暂时下掉最近列表
            getMentionsList();
            setListDataStatus('');
            setLoadingStatus(false);
            return;
        }
        getSearchData(inputVal).then(resultData => {
            const curInputVal = inputRef && inputRef?.current?.value;
            if (curInputVal !== inputVal) {
                return;
            }
            if (!(resultData instanceof Array)) {
                throw new Error(resultData as string);
            }
            !resultData?.length && setListDataStatus(STATUS.noSearch);
            resultData && resultData?.length && setListDataStatus('');
            resultData && getListDataChange(resultData);
            setLoadingStatus(false);
            feLogger(searchScene({
                position: isShare ? 'share' : 'add',
            }));
        }).catch(err => {
            setListDataStatus(STATUS.searchError);
            setLoadingStatus(false);
            console.log(err);
        });
    }, [getListDataChange, getMentionsList, getSearchData, isShare, loading]);

    // UPGRADE: 暂时下掉最近列表
    // 首次获取最近列表 && input为空刷新最近列表
    useEffect(() => {
        if ((!sugListData.length) && !recentlyTitle) {
            getMentionsList();
        }
        if (sugListData.length === 0) {
            setInputs('');
        }
        if (showRecent && sugListData.length === 1) {
            getMentionsList();
            setShowRecent(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sugListData]);

    useEffect(() => {
        if (memberList && memberList.length) {
            getMentionsList();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [memberList]);

    useEffect(() => {
        if (isShare && defaultShowEmpowerment && !isRepositoryPublic) {
            const haveWithOutPermission = sugListData.some(item => {
                return !item.roleName && !item.rocRoleName && !item.directoryRoleName;
            });
            setShowEmpowerment(haveWithOutPermission);
        }
    }, [defaultShowEmpowerment, isRepositoryPublic, isShare, sugListData]);

    useEffect(() => {
        if (isShare) {
            let params: string | number = '';
            isDocs && (params = ShareSource[`${getPageType()}`]);
            isRepository && (params = ShareSource.repository);
            isDepartment && (params = ShareSource.department);
            isRecentDocs && (params = ShareSource.recent);
            const data: any = {
                type: params,
                page_id: docGuid,
                kb_id: repository?.repositoryGuid,
                kb_org_id: repository?.groupGuid,
            };
            if (params === ShareSource.doc || params === ShareSource.sheet) {
                data.docType = params === ShareSource.doc ? LOG_DOC_TYPE.doc : LOG_DOC_TYPE.sheet;
                data.pageId = docGuid;
            }
            feLogger(enterShareToRuLiuPopper(data));
        }
        isInvite && (feLogger(enterAddMemberModal({
            type: DocType[`${getPageType()}`],
        })));
    }, [isShare, isInvite, isDocs, isRepository, isDepartment, isRecentDocs, docGuid, repository]);

    // 协作成员重试
    function handleRetryGetMember() {
        getMentionsList();
    }

    // 搜索重试
    function handleRetryGetSearchList() {
        inputsChange(inputs);
    }

    // 添加成员时选择发送如流会话卡片
    const handleChangeInviteAndShare = useCallback((ev: any) => {
        if (sugListData.some(item => item.isExternalUser && ev.target.checked)) {
            toast({
                type: ToastType.Error,
                content: '外部员工不会接收到如流通知',
            });
        }
        setShareForInvite(ev.target.checked);
    }, [sugListData]);

    function handleMouseDown(e: React.MouseEvent<HTMLDivElement>) {
        e.stopPropagation();
        if (inputRef && inputRef.current) {
            requestAnimationFrame(() => {
                inputRef.current?.focus();
            });
        }
    }

    const listDataRender = () => {
        if (recentlyTitle && listDataStatus === STATUS.noData) {
            return (<NoPerson
                text="暂无人员"
                svg={LoadNoResultSvg}
            />);
        } else if (listDataStatus === STATUS.noSearch) {
            return (<NoPerson
                text="暂时没有找到结果呢"
                svg={LoadNoDataSvg}
            />);
        } else if (listDataStatus === STATUS.searchError) {
            return (<NoPerson
                text="网络躺平了，"
                linkText="点一下唤醒ta吧~"
                retry={handleRetryGetSearchList}
                svg={LoadFailedSvg}
            />);
        // UPGRADE: 暂时下掉最近列表
        } else if (recentlyTitle && listDataStatus === STATUS.error) {
            return (<NoPerson
                text="网络躺平了，"
                linkText="点一下唤醒ta吧~"
                retry={handleRetryGetMember}
                svg={LoadFailedSvg}
            />);
        } else {
            return (
                listData.map((item, index) => {
                    return (
                        <div key={item.randomId} className={getCls('checkBoxListItem')} onMouseDown={handleMouseDown}>
                            {
                                // 第一层列表肯定展示
                                <CheckItem
                                    key={item.randomId}
                                    index={`${index + 1}`}
                                    handleClickGroupBtn={handleClickGroupBtn}
                                    handleCheckBox={handleCheckBox}
                                    itemData={item}
                                    powerListOptions={powerListOptions}
                                    shareInviteConfig={shareInviteConfig}
                                    memberInfoMaxWidth={memberInfoMaxWidth}
                                    inputVal={inputs}
                                    isRecently={!!recentlyTitle}
                                    repository={repository}
                                />
                            }
                            {
                                // 群成员按钮  展开 && 有值  的时候展示
                                item.openChildStatus && item.childrenMember ?
                                    <div>
                                        {
                                            item.childrenMember && item.childrenMember.map(
                                                (childItem: Iitems, childernIndex) => {
                                                    return (
                                                        <CheckItem
                                                            isChild
                                                            key={childItem.randomId}
                                                            index={`${index + 1}.${childernIndex + 1}`}
                                                            className={
                                                                item?.childrenMember ?
                                                                    getCls('childStyle') : ''
                                                            }
                                                            handleClickGroupBtn={handleClickGroupBtn}
                                                            handleCheckBox={handleCheckBox}
                                                            itemData={childItem}
                                                            powerListOptions={powerListOptions}
                                                            shareInviteConfig={shareInviteConfig}
                                                            memberInfoMaxWidth={memberInfoMaxWidth}
                                                            inputVal={inputs}
                                                            isRecently={!!recentlyTitle}
                                                            repository={repository}
                                                        />
                                                    );
                                                })
                                        }
                                    </div>
                                    : null
                            }
                        </div>
                    );
                })
            );
        }
    };

    const deptDataRender = () => {
        return (
            deptMsg.map((item, index) => {
                return (
                    <div key={item.randomId} className={getCls('checkBoxListItem')} onMouseDown={handleMouseDown}>
                        <CheckItem
                            key={item.randomId}
                            index={`${index + 1}`}
                            handleClickGroupBtn={handleClickGroupBtn}
                            handleCheckBox={handleCheckBox}
                            itemData={item}
                            powerListOptions={powerListOptions}
                            shareInviteConfig={shareInviteConfig}
                            memberInfoMaxWidth={memberInfoMaxWidth}
                            repository={repository}
                        />
                    </div>
                );
            })
        );
    };

    async function getRecommendGroup() {
        try {
            setRecommendGroupState(true);
            const ksServer = await sdk.getKsServer();
            const result = await ksServer.getGroupMatch(
                sugListData.map(item => {
                    return item.avatar || '';
                }),
                repository?.repositoryGuid || '',
                docGuid || ''
            );
            setRecommendGroup(
                result.map((item: any) => {
                    return {
                        groupId: item.groupId,
                        groupName: item.groupName,
                        power: item.permissionName || 'noPower',
                    };
                })
            );
            setRecommendGroupState(false);
        } catch (error) {
            console.log(error);
            setRecommendGroupState(false);
        }
    }

    useEffect(() => {
        if (isDepartment) {
            return;
        }
        const noUser = sugListData.find(item => {
            return item.memberType !== MemberType.User;
        });
        const externalUser = sugListData.find(item => {
            return item?.isExternalUser;
        });
        if (sugListData.length >= 3 && !noUser && !externalUser) {
            getRecommendGroup();
        } else {
            setRecommendGroup([]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sugListData]);

    function handleOnClick(itemData: any) {
        const item = {
            gid: itemData.groupId,
            name: itemData.groupName,
            userGuid: '',
            memberType: MemberType.RlGroup,
            checked: true,
        };
        feLogger(clickAddMemberPageRecommendGroup());
        setShowRecent(true);
        setSugListData([item]);
    }

    const showCancelBtn = showCancel || ((isDocs && isShare) || isInvite);
    const showCloseBtn = showClose || (isModal && isInvite);
    const showDepartmentItem = !hideDepartmentItem && deptMsg[0]?.nickname && isInvite && !inputs;

    return (
        <div className={classNames(styles.ShareInviteModalContent, className)}>
            <div className={getCls('searchAndResultBox')}>
                <div className={getCls('searchInput')}>
                    <div className={getCls('backMergeModal')}>
                        <div className={getCls('headTitle')}>
                            {
                                isDocs ?
                                    <Icon
                                        onClick={() => handleCancel()}
                                        className={getCls('backIcon')}
                                        svg={ArrowLeftSvg}
                                    /> :
                                    null
                            }
                            <span>
                                {title ?? (isShare ? '分享到如流' : '添加成员')}
                            </span>
                        </div>
                        {
                            showCloseBtn &&
                            <Icon
                                className={getCls('modalHeadIcon')}
                                size={IconSize.SM}
                                onClick={(e: any) => {
                                    // 阻止冒泡, 防止触发退出批量模式 (成本原因，如果后续影响到其他逻辑，再考虑将event传出AddAllDocPowerModal组件处理)
                                    e?.stopPropagation();
                                    handleCancel(isInvite && isModal);
                                }}
                                svg={CloseSvg}
                            />
                        }
                    </div>
                    <div>
                        <SearchInput
                            ref={inputRef}
                            powerListClassName={powerListClassName}
                            sugListData={sugListData}
                            inputChangeValue={inputsChange}
                            setInputs={setInputs}
                            handelDelSug={handelDelSug}
                            placeholder={
                                isShare
                                    ? kuPiper.openTextSlot('shareCollaboratePlaceholder')
                                    : kuPiper.openTextSlot('addCollaboratePlaceholder')
                            }
                            showPowerList={showPowerList}
                            powerListOptions={powerListOptions}
                            shareInviteConfig={shareInviteConfig}
                            powerValue={powerValue}
                            powerDisabled={powerDisabled}
                            onPowerChange={onPowerChange}
                        />
                    </div>
                </div>
                {/* 搜索结果 */}
                {
                    loadingStatus ?
                        <div className={getCls('searchSkeleton')}>
                            {
                                <Skeleton length={6} />
                            }
                        </div> :
                        <Loading
                            visible={loading}
                            className={classNames(
                                getCls('loadingbox'),
                                recentlyTitle && loading && getCls('recentLoading')
                            )}
                        >
                            {!recommendGroupState
                            && recommendGroup.length
                            && isInvite
                            && !isDepartment
                                ? <div className={styles.groupWrapper}>
                                    <div className={styles.addGroup}>
                                        <div className={styles.groupTitle}>
                                            <Icon svg={SettingWarnSvg} size={IconSize.MD} />
                                            <span className={styles.titleText}>检测到以上用户有
                                                <span className={styles.strongText}>「共同群聊」</span>
                                                ，建议添加群聊，群成员自动获权
                                            </span>
                                        </div>
                                        <SearchGroup itemData={recommendGroup} handleOnClick={handleOnClick} />
                                    </div>
                                </div>
                                : ''}
                            {/* 所属部门 */}
                            {
                                showDepartmentItem &&
                                    <>
                                        <span className={getCls('recentSpan')}>添加部门全部成员</span>
                                        {deptDataRender()}
                                    </>
                            }
                            {
                                // UPGRADE: 暂时下掉最近列表
                                recentlyTitle &&
                                    <span className={getCls('recentSpan')}>最近</span>
                            }
                            {
                                listDataRender()
                            }
                        </Loading>
                }
            </div>
            {/* 底部赋权 */}
            <div className={getCls('bottomBarShade')}></div>
            <div className={getCls('bottomBar')}>
                <div className={getCls('bottomBarLeftBox')}>
                    {
                        kuPiper.openNormalReplaceSlot(
                            {
                                scope: kuPiper.slotScopeMap.SpacePermission,
                                position: kuPiper.slotPositionMap.SpacePermission.AddPermissionCheckbox,
                                DefaultComponent: showEmpowerment && powerListOptions?.length ?
                                    <Checkbox
                                        defaultChecked={handleEmpowerment}
                                        onChange={handleChangeEmpowerment}
                                        className={getCls('bottomBarCheckbox')}
                                    >
                                        <span className={getCls('empowermentSpan')}>为无权用户添加权限</span>
                                        <div className={getCls('powerBox')}>
                                            <PowerList
                                                className={getCls('powerListMenu')}
                                                optionList={powerListOptions}
                                                disabled={powerDisabled}
                                                value={selectRoleName}
                                                onChange={onPowerChange}
                                            />
                                        </div>
                                    </Checkbox>
                                    :
                                    null,
                            }
                        )
                    }
                    {
                        kuPiper.openNormalReplaceSlot(
                            {
                                scope: kuPiper.slotScopeMap.SpacePermission,
                                position: kuPiper.slotPositionMap.SpacePermission.sendRuliuMessageCheckbox,
                                DefaultComponent: isInvite && isRuLiu && !isShow &&
                                (<div className={getCls('sendMessageCard')}>
                                    <Checkbox
                                        className={getCls('bottomBarCheckbox')}
                                        onChange={handleChangeInviteAndShare}
                                    >
                                        在如流内向对方发送当前文档
                                    </Checkbox>
                                    <Tooltip
                                        placement="top"
                                        content={'邮件组和部门不支持'}
                                    >
                                        <Icon svg={NoteTipSvg} size={IconSize.SM} />
                                    </Tooltip>
                                </div>),
                            }
                        )
                    }
                </div>
                <div className={classNames(getCls('bottomBarBtnBox'), !isDocs && getCls('biggerBtnBox'))}>
                    {
                        showCancelBtn &&
                            <Button
                                size={ButtonSize.XS}
                                onClick={() => handleCancel()}
                                className={classNames(
                                    getCls('bottomBarBtn'), getCls('cancelBtn'),
                                    shareInviteBtnDisabled() && getCls('cancelDisabledBtn')
                                )}
                            >
                                取消
                            </Button>
                    }
                    <Button
                        size={ButtonSize.XS}
                        disabled={shareInviteBtnDisabled()}
                        onClick={handleShareInvite}
                        className={
                            classNames(
                                getCls('bottomBarBtn'), getCls('shareInviteBtn'),
                                shareInviteBtnDisabled() && getCls('shareInviteDisabledBtn')
                            )
                        }
                    >
                        {isShare ? '分享' : '确定'}
                    </Button>
                </div>
            </div>
        </div>
    );
}
